export const logoShapeMap = {
  hide: 'display-none',
  horizontal: 'rounded-none',
  round: 'rounded-circle'
};
